import HeaderPortal from "components/portal/header-portal";
import { List, Icon } from "components";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import { Button } from "ui/components/button";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { eventBus } from "utils/eventBus";
import { useRemoveTestimonials } from "./mutation";
import CreateTestimonialsDialog from "./input";
import { MENU } from "icons";

export default function Testimonials() {
    const { casestudyId } = useParams();
    const [dialogOpen, setDialogOpen] = useState(false);
    const removeTestimonial = useRemoveTestimonials({
        onSuccess: () => {
            eventBus.emit("refresh:list", `testimonialstestimonials${casestudyId}`);
        },
    });
    const fields = [
        "id",
        "feedback",
        "case_study.id",
    ];
    const columns = [
        {
            id: "feedback",
            header: "Feedback",
            accessorKey: "feedback",
        },
        {
            id: "actions",
            header: "",
            accessorKey: "id",
            cell: ({ row }) => {
                const id = row.original.id;
                return (
                    <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button size="icon" variant="outline">
                                    <Icon icon={MENU} className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <DropdownMenuItem
                                    onClick={() => removeTestimonial.mutateAsync({ id })}
                                    disabled={removeTestimonial.isPending}
                                    className="cursor-pointer"
                                >
                                    Delete
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                );
            },
            sortable: false,
            meta: { align: "right" },
        },
    ];

    const defaultFilters = {
        case_study: {
            id: {
                _eq: casestudyId,
            }
        },
    };

    const handleCreate = () => {
        setDialogOpen(true);
    };

    return (
        <div className="flex-1">
            <HeaderPortal>
                <Button onClick={handleCreate}>
                    Add
                </Button>
            </HeaderPortal>
            <List
                title="Testimonials"
                storageKey={`testimonials${casestudyId}`}
                endPoint="testimonials"
                filters={defaultFilters}
                columns={columns}
                meta={{ fields }}
                hidePagination={true}
                showSearch={false}
                perPage={10}
                sortBy="date_created"
            />
            <CreateTestimonialsDialog
                open={dialogOpen}
                onOpenChange={setDialogOpen}
            />
        </div>
    );
}
